import {
  DELETE_PRODUCT,
  GET_PRODUCT_DETAILS,
  GET_PRODUCT_LIST,
} from "../constant/Type";

const initialState = {
  product: null,
  selected_product: null,
  loading: true,
};

const productReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_PRODUCT_LIST:
      return {
        ...state,
        product: payload,
        loading: false,
      };
    case GET_PRODUCT_DETAILS:
      return {
        ...state,
        selected_product: payload,
        loading: false,
      };
    case DELETE_PRODUCT:
      return {
        ...state,
        product: [...state.product.filter((prod) => prod._id !== payload)],

        loading: false,
      };
    default:
      return state;
  }
};

export default productReducer;
